var Handlebars = require("../../node_modules/.pnpm/handlebars@4.7.8_patch_hash=53ad8d748fa2ca3a7a0502c46f2ed1236eef8162efec84c06849dc83ad9e28e9/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.strict, alias2=container.lambda, alias3=container.escapeExpression;

  return "<img src=\""
    + alias3(alias2(alias1(depth0, "preview_url", {"start":{"line":1,"column":12},"end":{"line":1,"column":23}} ), depth0))
    + "\" data-insert-url=\""
    + alias3(alias2(alias1(depth0, "insert_url", {"start":{"line":1,"column":46},"end":{"line":1,"column":56}} ), depth0))
    + "\" class=\"tenor-gif\" tabindex=\"0\" loading=\"lazy\" data-gif-index=\""
    + alias3(alias2(alias1(depth0, "gif_index", {"start":{"line":1,"column":124},"end":{"line":1,"column":133}} ), depth0))
    + "\"/>\n";
},"useData":true});